import {
	Account,
	ACCOUNT_USER_ROLE,
	Dataset,
	Map,
	User,
} from "~auth/types/__generated/gql/graphql";

export const isAccountOwner = (
	accountLikeObj?: Pick<Account, "_currentUserRole">,
) => {
	return (
		!!accountLikeObj &&
		accountLikeObj._currentUserRole === ACCOUNT_USER_ROLE.OWNER
	);
};

export const isMapCreator = (
	mapLikeObj?: Pick<Map, "userId">,
	userLikeObj?: Pick<User, "id">,
) => {
	return !!mapLikeObj && !!userLikeObj && mapLikeObj.userId === userLikeObj.id;
};

export const isDatasetCreator = (
	datasetLikeObj?: Pick<Dataset, "userId">,
	userLikeObj?: Pick<User, "id">,
) => {
	return (
		!!datasetLikeObj &&
		!!userLikeObj &&
		datasetLikeObj.userId === userLikeObj.id
	);
};

export const ACCOUNT_ROLES_HIERACHY: `${ACCOUNT_USER_ROLE}`[] = [
	ACCOUNT_USER_ROLE.VIEWER,
	ACCOUNT_USER_ROLE.EDITOR,
	ACCOUNT_USER_ROLE.ADMIN,
	ACCOUNT_USER_ROLE.OWNER,
] as const;

export const hasEqualOrHigherAccessThanSpecifiedRole = (
	accountLikeObj?: Pick<Account, "_currentUserRole">,
	role?: `${ACCOUNT_USER_ROLE}`,
) => {
	return (
		!!accountLikeObj?._currentUserRole &&
		!!role &&
		ACCOUNT_ROLES_HIERACHY.indexOf(accountLikeObj._currentUserRole) >=
			ACCOUNT_ROLES_HIERACHY.indexOf(role)
	);
};
